import api from '../api';

export const isWorking = async () => {
  try {
    const response = await api.get('/cliente/is/working');
    return {
      error: false,
      online: response.data.online,
      message: response.data.message,
    };
  } catch (error) {
    console.error('Erro ao consultar horário de atendimento:', error);
    return { error: true, online: false, message: 'Servidor em manutenção' };
  }
};
